import { type ConvoAIStreamingConfig } from '../models/ConvoAIStreamingConfig';

export const logConvoAIInfo = (message: string, config: ConvoAIStreamingConfig, data: object) => {
	if (config.enableLocalVerboseLogs) {
		// eslint-disable-next-line no-console
		console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
	}
};
